import { render, staticRenderFns } from "./ChainForm.vue?vue&type=template&id=0c01aa64&scoped=true"
import script from "./ChainForm.vue?vue&type=script&lang=js"
export * from "./ChainForm.vue?vue&type=script&lang=js"
import style0 from "./ChainForm.vue?vue&type=style&index=0&id=0c01aa64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01aa64",
  null
  
)

export default component.exports